import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import { Button, Dimmer, Header, Icon, Loader } from "semantic-ui-react"
import axios from "../axios"
import 'styled-components/macro'

export const error_message = (e) => {
    if (e.response)
        return e.response.data.message
    else
        return e.message
}


const Verify = () => {
    const [t,]=useTranslation("global")
    const [loading, setLoading] = useState(true)
    const [message, setMessage] = useState("")
    const history=useHistory()
    const query=useQuery()
    
    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }
    const load = async () => {
        try {
            const { data } = await axios.post("/api/user/verify", {
                token: query.get("token")
            })
            if (data === "ok") {
                setMessage(("account_verified"))
            }else{
                setMessage(("account_not_verified"))
            }
        } catch (e) { setMessage(t(error_message(e))) }
        setLoading(false)
    }
    useEffect(() => {
        load()
    }, [])

    if (loading) {
        return <Dimmer inverted active>
            <Loader />
        </Dimmer>
    }

    return (
        <>
            <div css="display:flex;align-items:center;justfy-content:center;height:100vh;">
                <Header as='h2' icon textAlign="center">
                    <Icon color="teal" name={message === "account_verified" ? "check circle outline" : "close"} />
                    {t(message)}
                    {message=="account_verified"&&<div><Button color="teal" circular primary style={{marginTop:"1rem"}} onClick={()=>{history.push("/")}}>{t("home_page")}</Button></div>}
                </Header>
            </div>
        </>
    )
}

export default Verify